<template>
  <section class="container-fluid">
    <CRow class="justify-content-center">
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            <strong>Editar tipo de pensión</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="edit">
                <section class="row">
                  <!-- Pénsum -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="syllabus_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="syllabus_id"
                          >Pénsum</label
                        >
                        <b-form-select
                          v-model="syllabusTuition.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="syllabus_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un pénsum--</b-form-select-option
                          >
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Nombre -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="name"
                        rules="required|uniqueName|max:30"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="name">Nombre</label>
                        <input
                          type="text"
                          v-model="syllabusTuition.name"
                          class="form-control form-control-sm"
                          id="name"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <!-- Gestión -->
                  <div class="col">
                    <div class="form-group required">
                      <label class="control-label" for="year">Gestión</label>
                      <input
                        type="number"
                        v-model="syllabusTuition.year"
                        class="form-control form-control-sm"
                        id="year"
                        readonly
                      />
                    </div>
                  </div>
                  <!-- 1ra Cuota -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="first_tuition_price"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="first_tuition_price"
                          >1ra. cuota</label
                        >
                        <currency-input
                          v-model="syllabusTuition.first_tuition_price"
                          class="form-control form-control-sm"
                          id="first_tuition_price"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- 2da cuota -->
                  <div class="col">
                    <div class="form-group required">
                      <ValidationProvider
                        name="second_tuition_price"
                        rules="required"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="second_tuition_price"
                          >desde la 2da. cuota</label
                        >
                        <currency-input
                          v-model="syllabusTuition.second_tuition_price"
                          class="form-control form-control-sm"
                          id="second_tuition_price"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label for="enabled">Estado</label>
                      <br />
                      <CSwitch
                        :color="color"
                        v-bind="mode"
                        :checked.sync="syllabusTuition.enabled"
                        id="enabled"
                      />
                    </div>
                  </div>
                </section>

                <router-link
                  to="/tipos-de-pensiones"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a
                    :href="href"
                    class="card-header-action btn btn-sm btn-danger"
                    @click="navigate"
                  >
                    <CIcon size="sm" name="cil-x-circle" /> Cancelar
                  </a>
                </router-link>
                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || editLoader"
                >
                  <span v-if="!editLoader">
                    <CIcon size="sm" name="cil-save" />
                    Editar
                  </span>
                  <span v-if="editLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import SyllabusTuitions from "@/plugins/services/syllabus-tuitions";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "SyllabusTuitionEdit",
  components: { BFormInvalidFeedback, BFormSelect, BFormSelectOption },
  data() {
    return {
      syllabusTuition: {},
      currentName: "",
      currentVersion: "",
      mode: { shape: "pill" },
      color: "primary",
      editLoader: false,
      dataLoader: false,
      syllabusOptions: [],
      configDate: {
        dateFormat: "Y",
        showMonths: 1,
        allowInput: true,
      },
      msgValidatorUniqueName: "",
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("uniqueName", {
      validate: this.isUniqueName,
      message: () => {
        return this.msgValidatorUniqueName;
      },
    });
  },
  mounted() {
    this.getSyllabus();
    const { id } = this.$route.params;
    this.getData(id);
  },
  watch: {
    "syllabusTuition.syllabus_id"(val) {
      this.computedForm.refs["name"].validate();
    },
  },
  methods: {
    getData(id) {
      this.dataLoader = true;
      SyllabusTuitions.getOne(id)
        .then((res) => {
          this.syllabusTuition = res.data;
          this.currentName = this.syllabusTuition.name;
          this.dataLoader = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Tipo de pensión no encontrada.");
            this.$router.push("/tipos-de-pensiones");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.$router.push("/tipos-de-pensiones");
          }
          this.dataLoader = false;
        });
    },
    edit() {
      this.editLoader = true;
      const { id } = this.$route.params;
      this.syllabusTuition.modified_by = this.userAuth.username;
      SyllabusTuitions.edit(id, this.syllabusTuition)
        .then((res) => {
          this.editLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            this.$router.push("/tipos-de-pensiones");
          } else {
            Utils.setFlash("danger", res.data.message);
            this.$router.push("/tipos-de-pensiones");
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Tipo de pensión no encontrada.");
            this.$router.push("/tipos-de-pensiones");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al editar(500).");
            this.$router.push("/tipos-de-pensiones");
          }
        });
    },
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async isUniqueName() {
      if (this.syllabusTuition.syllabus_id == null) {
        this.msgValidatorUniqueName = "Debe seleccionar un Pénsum.";
        return false;
      }
      return SyllabusTuitions.existName(
        this.syllabusTuition.name,
        this.currentName,
        this.syllabusTuition.syllabus_id
      )
        .then((res) => {
          this.msgValidatorUniqueName = res.data.message;
          if (res.data.data) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
  },
};
</script>
